import { I18n } from '@lingui/core'

import {
  AT_TYPE_CART_BOTTOM,
  AT_TYPE_CART_TOP,
  TYPE_ADD_TO_CART_CENTER,
  TYPE_ADD_TO_CART_TOP,
  TYPE_CART_BOTTOM,
  TYPE_CART_TOP,
  TYPE_CATEGORY,
  TYPE_CSW_HEADER_TITLE,
  TYPE_MY_ACCOUNT_OVERVIEW,
  TYPE_OWN_BRANDS_ON_HOMEPAGE,
  TYPE_PDP_AV,
  TYPE_PDP_CENTER,
  TYPE_PDP_NA,
  TYPE_REDPOINTS_PAGE,
  TYPE_SEARCH_NO_RESULTS,
  TYPE_START_PAGE,
  TYPE_START_PAGE_BOTTOM,
} from 'shared/consts/crosssellWidgets'
import { ML_TENANTS } from 'shared/consts/multilanguage'
import {
  CTA_BUTTON_ON_ALL_CSW,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import { getExperiment } from 'shared/experiments/utils/experiments'
import type { Experiment, Tenant } from 'types/shopConfig'

export const shouldShowBuyButton = (
  wid: number,
  widgets: Record<string, number>
): boolean =>
  wid === widgets[TYPE_CART_TOP] ||
  wid === widgets[TYPE_CART_BOTTOM] ||
  wid === AT_TYPE_CART_TOP ||
  wid === AT_TYPE_CART_BOTTOM

export const showBuyButtonForAllCSWExperiment = (
  experiments: Experiment[]
): boolean => {
  const ctaButtonOnAllCSW = getExperiment(CTA_BUTTON_ON_ALL_CSW, experiments)

  return (
    ctaButtonOnAllCSW.isEnabled &&
    ctaButtonOnAllCSW.variant === EXPERIMENT_VARIATION.V1
  )
}

export const titleFromLokalise = ML_TENANTS

export const getSliderTitle = (
  i18n: I18n,
  widgets: Record<string, number>,
  wid: number,
  defaultTitle: string,
  tenant: Tenant
): string => {
  if (titleFromLokalise.includes(tenant)) {
    switch (wid) {
      case widgets[TYPE_PDP_CENTER]:
        return i18n._('general.crosssell.seenTogether')
      case widgets[TYPE_CART_TOP]:
        return i18n._('cart.crosssell.recommended')
      case widgets[TYPE_CART_BOTTOM]:
        return i18n._('cart.crosssell.wellBeing')
      case widgets[TYPE_ADD_TO_CART_TOP]:
        return i18n._('cartintermediate.crosssell.clientsBuyAlso')
      case widgets[TYPE_ADD_TO_CART_CENTER]:
        return i18n._('cartintermediate.crosssell.recommended')
      case widgets[TYPE_OWN_BRANDS_ON_HOMEPAGE]:
        return i18n._('general.crosssell.ownBrandsOnHomepage')
      case widgets[TYPE_START_PAGE_BOTTOM]:
        return i18n._('general.crosssell.topMonth')
      case widgets[TYPE_START_PAGE]:
        return i18n._('general.crosssell.popular')
      case widgets[TYPE_PDP_AV]:
        return i18n._('product.crosssell.noSuccessor')
      case widgets[TYPE_PDP_NA]:
        return i18n._('product.crosssell.outOfStock')
      case widgets[TYPE_SEARCH_NO_RESULTS]:
        return i18n._('search.crosssell.noResults')
      case widgets[TYPE_CATEGORY]:
        return i18n._('category.crosssell.category')
      case widgets[TYPE_CSW_HEADER_TITLE]:
        return i18n._('general.crosssell.title')
      case widgets[TYPE_REDPOINTS_PAGE]:
        return i18n._('general.crosssell.title')
      case widgets[TYPE_MY_ACCOUNT_OVERVIEW]:
        return i18n._('search.crosssell.noResults')
      default:
        return defaultTitle
    }
  } else {
    return defaultTitle
  }
}
